document.addEventListener('DOMContentLoaded', function () {
  /* If it's not a landing page, then do nothing */
  if (!document.querySelector('.landing-page__template')) {
    return;
  }

  document.querySelectorAll('.landing-page__template a').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});
